<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="bsd-section">
          <breadcrumb />
        </div>

        <div class="bsd-section">
          <div class="z-title z-title--small">
            Cadastrar novo cartão de crédito
          </div>
        </div>

        <card-form card-type="credit_card" @cardCreated="goToCardSelectionPage()" />
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from 'components/breadcrumb';
import CardForm from 'components/card-form';

export default {
  components: {
    Breadcrumb,
    CardForm,
  },
  methods: {
    goToCardSelectionPage() {
      this.$router.push({ name: 'nb-credit-card' });
    },
  },
};
</script>
